import { useMemo } from "react";
import useResources from "./use-resources";
import useProfileFilter from "./use-profile-filter";

const ROOT_PATH = "contacts";

export default function useContacts() {
  const {
    resources: allContacts,
    error,
    isLoading,
    create,
    update,
    del,
  } = useResources(ROOT_PATH);
  const { matchesProfileFilter, isFilterActive } = useProfileFilter();

  const contacts = useMemo(() => {
    if (!isFilterActive) return allContacts;
    return allContacts.filter(
      (contact) =>
        contact.id_profile_bailleur == null ||
        matchesProfileFilter(contact.id_profile_bailleur),
    );
  }, [allContacts, isFilterActive, matchesProfileFilter]);

  return {
    contacts,
    error,
    isLoading,
    createContact: create,
    updateContact: update,
    deleteContact: del,
  };
}
